import Vue from 'vue'
import Router from 'vue-router'
import store from './store/index'

import Home from '@/pages/Home'
import Admin from '@/pages/Admin'
import Login from '@/pages/Login'
import VisitorValidation from '@/pages/VisitorValidation'

// import MediaLibrary from '@/pages/MediaLibrary'
import ChangePassword from '@/pages/ChangePassword'
import Editor from '@/pages/Editor'
import Scheme from '@/pages/Scheme'
import Partners from '@/pages/Partners'
import AddPartner from '@/pages/AddPartner'
import EditPartner from '@/pages/EditPartner'
import Agents from '@/pages/Agents'
import AddAgent from '@/pages/AddAgent'
import EditAgent from '@/pages/EditAgent'
import NotFound from '@/pages/NotFound'

import User from '@/pages/AdminUser'
import Survey from '@/pages/AdminSurvey'
import History from '@/pages/AdminHistory'
import Group from '@/pages/AdminGroup'
import RateCards from '@/pages/RateCards'

import PrivacyPolicy from '@/pages/PrivacyPolicy'

import AddGroup from '@/pages/AddUserGroup'
import EditGroup from '@/pages/EditUserGroup'

import AddRateCards from '@/pages/AddRateCards'
import EditRateCards from '@/pages/EditRateCards'

import Quota from '@/pages/Quota'

import Report from '@/pages/Report'

import SurveyCustomization from '@/pages/SurveyCustomization'

import Templates from '@/pages/Templates'

import { earlyExitReduce } from '@/utils/array'

Vue.use(Router)

const router = new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'home',
      component: Home,
    },
    // {
    //   path: '/medialibrary',
    //   name: 'medialibrary',
    //   component: MediaLibrary,
    //   beforeEnter(to, from, next) {
    //     if (!store.getters.hasSurvey) next('/')
    //     else next()
    //   },
    // },
    {
      path: '/admin',
      name: 'admin',
      component: Admin,
      beforeEnter(to, from, next) {
        // const store = require('./store').default // Vue said it was never used.
        if (to.name === 'admin') next('/admin/password')
        else next()
      },
      children: [
        {
          name: 'user',
          path: 'user',
          component: User,
          beforeEnter(to, from, next) {
            if (store.getters.accType !== 'VzAdmin' && store.getters.accType !== 'Root')
              next('/admin/password')
            else next()
          },
        },
        {
          name: 'survey',
          path: 'survey',
          component: Survey,
          beforeEnter(to, from, next) {
            if (store.getters.accType !== 'Root' && store.getters.accType !== 'VzAdmin')
              next('/admin/password')
            else next()
          },
        },
        {
          name: 'history',
          path: 'history',
          component: History,
          beforeEnter(to, from, next) {
            if (store.getters.accType !== 'Root') next('/admin/password')
            else next()
          },
        },
        {
          name: 'group',
          path: 'group',
          component: Group,
          beforeEnter(to, from, next) {
            if (store.getters.accType !== 'Root') next('/admin/password')
            else next()
          },
          children: [
            {
              name: 'addgroup',
              path: '/addgroup',
              component: AddGroup,
            },
            {
              name: 'editgroup',
              path: '/editgroup',
              component: EditGroup,
            },
          ],
        },
        {
          name: 'rateCards',
          path: 'rateCards',
          component: RateCards,
          beforeEnter(to, from, next) {
            if (store.getters.accType !== 'Root') next('/admin/password')
            else next()
          },
          children: [
            {
              name: 'addRateCards',
              path: '/addRateCards',
              component: AddRateCards,
            },
            {
              name: 'editRateCards',
              path: '/editRateCards',
              component: EditRateCards,
            },
          ],
        },
        {
          path: 'password',
          name: 'password',
          component: ChangePassword,
        },
      ],
    },
    {
      path: '/quota',
      name: 'quota',
      component: Quota,
    },
    {
      path: '/report',
      name: 'report',
      component: Report,
    },
    {
      path: '/theme',
      name: 'survey-theme',
      component: SurveyCustomization,
      beforeEnter(to, from, next) {
        if (!store.getters.hasSurvey) next('/')
        else next()
      },
    },
    {
      path: '/login',
      name: 'login',
      component: Login,
      beforeEnter(to, from, next) {
        if (store.getters.isLogged()) next('/')
        else next()
      },
    },
    {
      path: '/privacy-policy',
      name: 'privacy-policy',
      component: PrivacyPolicy,
    },
    {
      path: '/visitor-validation',
      name: 'visitor-validation',
      component: VisitorValidation,
      beforeEnter(to, from, next) {
        if (store.getters.isLogged()) next('/')
        else next()
      },
    },
    {
      path: '/editor',
      name: 'editor',
      component: Editor,
      beforeEnter(to, from, next) {
        if (!store.getters.hasSurvey) next('/')
        else next()
      },
    },
    {
      path: '/scheme',
      name: 'scheme',
      component: Scheme,
      beforeEnter(to, from, next) {
        if (!store.getters.hasSurvey) next('/')
        else next()
      },
    },
    {
      path: '/partners',
      name: 'partners',
      component: Partners,
      beforeEnter(to, from, next) {
        if (!store.getters.hasSurvey) next('/')
        else next()
      },
      children: [
        {
          name: 'addpartner',
          path: '/addpartner',
          component: AddPartner,
        },
        {
          name: 'editpartner',
          path: '/editpartner',
          component: EditPartner,
        },
      ],
    },
    {
      path: '/agents',
      name: 'agents',
      component: Agents,
      beforeEnter(to, from, next) {
        if (!store.getters.hasSurvey) next('/')
        else next()
      },
      children: [
        {
          name: 'addagent',
          path: '/addagent',
          component: AddAgent,
        },
        {
          name: 'editagent',
          path: '/editagent',
          component: EditAgent,
        },
      ],
    },
    {
      path: '/templates',
      name: 'templates',
      component: Templates,
      beforeEnter(to, from, next) {
        if (!store.getters.hasSurvey) next('/')
        else next()
      },
    },
    {
      path: '*',
      name: 'notFound',
      component: NotFound,
    },
  ],
})

const ALLOW_TRAFFIC = 'ALLOW'

const routingChecks = {
  visitorValidation: (to, from) => {
    const isLogged = store.getters.isLogged()
    const visitorValidated = store.getters.isVisitorAccess

    const visitorAccess =
      !isLogged && to.path === '/report' && to.query.visitor && to.query.survey

    if (visitorAccess && visitorValidated) return ALLOW_TRAFFIC

    if (visitorAccess) return { name: 'visitor-validation', query: to.query }

    const isValidation =
      !isLogged &&
      to.path === '/visitor-validation' &&
      to.query.visitor &&
      to.query.survey

    if (isValidation) return ALLOW_TRAFFIC
  },

  unAuthorizedAccess: (to, from) => {
    const isLogged = store.getters.isLogged()

    const openRoutes = ['login', 'privacy-policy']

    const unAuthorizedAccess = !isLogged && !openRoutes.includes(to.name)

    if (unAuthorizedAccess) return { name: 'login' }
  },

  passwordChangeNeeded: (to, from) => {
    const okRoutes = ['login', 'privacy-policy', 'password']

    const passwordChangeNeeds = !okRoutes.includes(to.name) && store.getters.firstAccess

    if (passwordChangeNeeds) return { name: 'password' }
  },
}

router.beforeEach((to, from, next) => {
  const routingConfig = earlyExitReduce(
    Object.values(routingChecks),
    (_, nextChecker) => nextChecker(to, from),
    result => !!result || result === ALLOW_TRAFFIC,
    null,
  )

  next(routingConfig === ALLOW_TRAFFIC ? undefined : routingConfig)
})

export default router
